<template>
  <transition
    enter-active-class="animated fadeIn fastest"
    leave-active-class="animated fadeOut fastest"
    mode="out-in"
  >
    <div
      class="tab-pane"
      v-if="isActiveData"
      :class="{'active': isActiveData}"
      :id="id"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'BlastTab',

    props: {
      id: {
        required: true,
      },
      label: {
        required: true,
      },
      isActive: {
        type: Boolean,
        default: false,
      },
      classes: {
        default: null,
      },
    },

    data() {
      return {
        isActiveData: false,
      };
    },

    mounted() {
      this.isActiveData = this.isActive;
    },
  };
</script>

<style scoped>
  .tab-pane {
    clear: both;
  }
</style>
